// extracted by mini-css-extract-plugin
export var deleteIcon = "_n2-5";
export var deleteOption = "_n2-3";
export var divider = "_n2-2";
export var downloadIcon = "_n2-4";
export var drawer = "_n2-0";
export var drawerFooter = "_n2-6";
export var drawerOpen = "_n2-1";
export var highlighted = "_n2-7";
export var lighterHighlight = "_n2-8";